import React, { useEffect, useState } from 'react';
import { CButton, CCard, CCardHeader, CCol, CRow } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { getAll } from 'src/services/ChartOfAccounts';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';

function ChartOfAccounts() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);

  const navigate = useNavigate();

  async function fetchMainData() {
    const res = await getAll();
    const rows =
      res.coa &&
      res.coa.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          name: item.name,
          code: item.code,
          categoryName: item.categoryName,
          description: item.description,
          categoryID: item.category_id
          // balance: formatter('currency', item?.balance ?? 0)
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width: '100' },
      { field: 'code', headerName: 'Code', width: '150' },
      { field: 'name', headerName: 'Name', width: '300' },
      { field: 'categoryName', headerName: 'Category', width: '300' }
      // { field: 'description', headerName: 'Description' }
      // { field: 'balance', headerName: 'Balance' }
    ];

    setDataColumns(columns);
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate('/coa-actions', { state: params.row });
  }

  return (
    <div style={{ color: 'black' }}>
      <CCard>
        <CCardHeader>Chart of Accounts</CCardHeader>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol xs={9} lg={9}></CCol>
            <CCol xs={3} lg={3} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/coa-actions');
                }}
              >
                Create
              </CButton>
              &nbsp;
              <CButton
                style={{ backgroundColor: 'white', color: 'black' }}
                onClick={() => {
                  navigate('/coa-actions');
                }}
              >
                Download
              </CButton>
            </CCol>
          </CRow>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default ChartOfAccounts;
